'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _blocks = require('../../blocks');

var _MenuItemFlyout = require('./MenuItemFlyout');

var _MenuItemFlyout2 = _interopRequireDefault(_MenuItemFlyout);

var _MenuItemTitle = require('./MenuItemTitle');

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuSubItemsList = require('./MenuSubItemsList');

var _MenuSubItemsList2 = _interopRequireDefault(_MenuSubItemsList);

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Compares the menu item's activePath or path to the current pathname.
 * Boolean returned indicates if the two match.
 * @param {object} props the component's props (may be next props)
 * @property {object} props.location a location object provided by the withRouter HOC
 * @property {object} props.menuItem a menuItem object provided by the menu groups list
 * @returns {boolean}
 */
function evaluateMenuItemActive(_ref) {
  var _ref$location$pathnam = _ref.location.pathname,
      pathname = _ref$location$pathnam === undefined ? '' : _ref$location$pathnam,
      _ref$menuItem = _ref.menuItem,
      activePath = _ref$menuItem.activePath,
      path = _ref$menuItem.path;

  if (activePath) {
    return activePath === pathname;
  }

  var primaryPath = pathname.split('/')[1];
  return !!(path && primaryPath && path.match(primaryPath) || path === '/' && !primaryPath);
}

var MenuItem = exports.MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      // A menu item's active state is based on the current route
      isActive: evaluateMenuItemActive(_this.props),
      // A menu item's highlighted state is based on the user's cursor position
      isHighlighted: false,
      // A menu item's highlighted state is based on the user's cursor position
      // + the left nav expanded state
      isFlyoutOpen: false
    }, _this.handleMouseEnter = function () {
      if (!_this.props.expanded) {
        _this.setState({
          isHighlighted: true,
          isFlyoutOpen: true
        });
      }
    }, _this.handleMouseLeave = function () {
      _this.setState({
        isHighlighted: false,
        isFlyoutOpen: false
      });
    }, _this.handleMouseEnterMenuItemTitle = function () {
      if (_this.props.expanded) {
        _this.setState({ isHighlighted: true });
      }
    }, _this.handleMouseLeaveMenuItemTitle = function () {
      if (_this.props.expanded) {
        _this.setState({ isHighlighted: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isActive = evaluateMenuItemActive(nextProps);
      this.setState({
        isActive: isActive
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          TextRenderer = _props.TextRenderer,
          expanded = _props.expanded,
          expandedMenus = _props.expandedMenus,
          handleExpandMenuClick = _props.handleExpandMenuClick,
          menuItem = _props.menuItem,
          menuGroupsLoading = _props.menuGroupsLoading,
          location = _props.location;
      var _state = this.state,
          isActive = _state.isActive,
          isHighlighted = _state.isHighlighted,
          isFlyoutOpen = _state.isFlyoutOpen;


      var menuKey = menuItem.icon + ':' + menuItem.path;
      var isMenuExpanded = !!(expanded && Array.isArray(expandedMenus) && (0, _lodash.includes)(expandedMenus, menuKey));

      return _react2.default.createElement(
        _blocks.LeftNav.MenuItem,
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        },
        _react2.default.createElement(_MenuItemTitle2.default, {
          TextRenderer: TextRenderer,
          expanded: expanded,
          handleExpandMenuClick: handleExpandMenuClick,
          isActive: isActive,
          isFlyoutOpen: isFlyoutOpen,
          isHighlighted: isHighlighted,
          isMenuExpanded: isMenuExpanded,
          menuItem: menuItem,
          menuGroupsLoading: menuGroupsLoading,
          menuKey: menuKey,
          onMouseEnter: this.handleMouseEnterMenuItemTitle,
          onMouseLeave: this.handleMouseLeaveMenuItemTitle
        }),
        isFlyoutOpen && !menuGroupsLoading ? _react2.default.createElement(_MenuItemFlyout2.default, {
          TextRenderer: TextRenderer,
          expanded: expanded,
          handleExpandMenuClick: handleExpandMenuClick,
          isActive: isActive,
          isFlyoutOpen: isFlyoutOpen,
          isHighlighted: isHighlighted,
          isMenuExpanded: isMenuExpanded,
          menuItem: menuItem,
          menuGroupsLoading: menuGroupsLoading,
          menuKey: menuKey,
          onMouseEnter: this.handleMouseEnterMenuItemTitle,
          onMouseLeave: this.handleMouseLeaveMenuItemTitle
        }) : _react2.default.createElement(_MenuSubItemsList2.default, {
          TextRenderer: TextRenderer,
          isFlyoutOpen: isFlyoutOpen,
          isMenuExpanded: isMenuExpanded,
          location: location,
          menuSubItems: menuItem.menuSubItems
        })
      );
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};
exports.default = MenuItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuItem.js
// module id = 1673
// module chunks = 2